import type { HttpClient } from '@angular/common/http';
import type { StateKey, TransferState } from '@angular/core';
import { makeStateKey } from '@angular/core';

import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

export function getContentConfigurationKey(key: string): string {
	if (key == null) {
		return 'fallback';
	}
	return stripBrowser(key.toString().split(':')[0].toLowerCase());
}

export function stripBrowser(value: string) {
	const prefix = 'browser-';
	if (value.startsWith(prefix)) {
		return value.substring(prefix.length);
	}
	return value;
}

export function fetchWithTransferState<T>(
	transferState: TransferState,
	http: HttpClient,
	key: string,
	url: string,
	options?: {
		params?: Record<string, string | number | boolean>;
		withCredentials?: boolean;
	},
): Observable<T> {
	const stateKey: StateKey<T> = makeStateKey<T>(key);

	if (transferState.hasKey(stateKey)) {
		return of(transferState.get<T>(stateKey, {} as T));
	}

	return http
		.get<T>(url, {
			...options,
			observe: 'body',
			responseType: 'json' as const,
		})
		.pipe(tap((data) => transferState.set(stateKey, data)));
}
